import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import {
  Alert,
  Card,
  Dialog,
  IconButton,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Form } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import BillEntryService from "../../Services/bl_entry/BillEntryService";
import Home from "../home/Home";

export default function BLEntry() {
  const [saveDsa, setSaveDsa] = useState(false);
  const [updateDsa, setUpdateDsa] = useState(false);
  const [printDsa, setPrintDsa] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const [saveAddDetailsDsa, setSaveAddDetailsDsa] = useState(false);
  const [updateAddDetailsDsa, setUpdateAddDetailsDsa] = useState(false);

  const [addDetailsDsa, setAddDetailsDsa] = useState(false);
  const [openAddDetails, setOpenAddDetails] = useState(false);

  const [entryDetails, setEntryDetails] = useState([]);
  const [addDetailsDialog, setAddDetailsDialog] = useState([]);

  // MAIN PAGE CODE START

  const [entryValues, setEntryValues] = useState({

    exportid:"",
    blno: "",
    consigneeadrs: "",
    notifyadrs: "",
    shipperadrs: "",
    deliveryagentdestination: "",
    precarriageby: "",
    placeofreceipt: "",
    oceanvessel: "",
    voyno: "",
    portofloading: "",
    portofdischarge: "",
    portofdly: "",
    mode_: "",
    route_: "",
    freightchagesamt: "",
    freightpayableat: "",
    nooriginalblmtd: "",
    placedateissue: "",
    otherparticulars: "",
    shippedonboard: "",
    updatedby: "",

  });

  const blnohandleChange = (e) => {
    setEntryValues({ ...entryValues, blno: e.target.value });
  };
  const consigneehandleChange = (e) => {
    setEntryValues({ ...entryValues, consigneeadrs: e.target.value });
  };
  const notifyhandleChange = (e) => {
    setEntryValues({ ...entryValues, notifyadrs: e.target.value });
  };
  const shipperhandleChange = (e) => {
    setEntryValues({ ...entryValues, shipperadrs: e.target.value });
  };
  const destinationhandleChange = (e) => {
    setEntryValues({...entryValues, deliveryagentdestination: e.target.value,});
  };
  const precarriagebyhandleChange = (e) => {
    setEntryValues({ ...entryValues, precarriageby: e.target.value });
  };
  const placeofreceipthandleChange = (e) => {
    setEntryValues({ ...entryValues, placeofreceipt: e.target.value });
  };
  const oceanvesselhandleChange = (e) => {
    setEntryValues({ ...entryValues, oceanvessel: e.target.value });
  };
  const voynohandleChange = (e) => {
    setEntryValues({ ...entryValues, voyno: e.target.value });
  };
  const portofloadinghandleChange = (e) => {
    setEntryValues({ ...entryValues, portofloading: e.target.value });
  };
  const portofdischargehandleChange = (e) => {
    setEntryValues({ ...entryValues, portofdischarge: e.target.value });
  };
  const portofdlyhandleChange = (e) => {
    setEntryValues({ ...entryValues, portofdly: e.target.value });
  };
  const modehandleChange = (e) => {
    setEntryValues({ ...entryValues, mode_: e.target.value });
  };
  const routehandleChange = (e) => {
    setEntryValues({ ...entryValues, route_: e.target.value });
  };
  const freightchagesamthandleChange = (e) => {
    setEntryValues({ ...entryValues, freightchagesamt: e.target.value });
  };
  const freightpayableathandleChange = (e) => {
    setEntryValues({ ...entryValues, freightpayableat: e.target.value });
  };
  const nooriginalblmtdhandleChange = (e) => {
    setEntryValues({ ...entryValues, nooriginalblmtd: e.target.value });
  };
  const placedateissuehandleChange = (e) => {
    setEntryValues({ ...entryValues, placedateissue: e.target.value });
  };
  const otherparticularshandleChange = (e) => {
    setEntryValues({ ...entryValues, otherparticulars: e.target.value });
  };
  const shippedonboardhandleChange = (e) => {
    setEntryValues({ ...entryValues, shippedonboard: e.target.value });
  };
  const updatedbyhandleChange = (e) => {
    setEntryValues({ ...entryValues, updatedby: e.target.value });
  };

  const EditEntryData = (edit) => {
    setEntryValues({
      ...entryValues,
      exportid:edit.export_id,
      blno:edit.bl_no,
      consigneeadrs: edit.consignee_adrs,
      notifyadrs: edit.notify_adrs,
      shipperadrs: edit.shipper_adrs,
      deliveryagentdestination: edit.delivery_agent_destination,
      precarriageby: edit.pre_carriage_by,
      placeofreceipt: edit.place_of_receipt,
      oceanvessel: edit.ocean_vessel,
      voyno: edit.voy_no,
      portofloading: edit.port_of_loading,
      portofdischarge: edit.port_of_discharge,
      portofdly: edit.port_of_dly,
      mode_: edit.mode,
      route_: edit.route,
      freightchagesamt: edit.freight_chages_amt,
      freightpayableat: edit.freight_payable_at,
      nooriginalblmtd: edit.no_original_bl_mtd,
      placedateissue: edit.place_date_issue,
      otherparticulars: edit.other_particulars,
      shippedonboard: edit.shipped_on_board,
      updatedby: edit.updated_by,
    });
    setSaveDsa(true);
    setUpdateDsa(false);
    setPrintDsa(false);
    setAddDetailsDsa(false);
    setUpdateAddDetailsDsa(true);
  };

  const SaveEntryData = () => {
    let SaveEntry = {

      bl_no: entryValues.blno,
      consignee_adrs: entryValues.consigneeadrs,
      notify_adrs: entryValues.notifyadrs,
      shipper_adrs: entryValues.shipperadrs,
      delivery_agent_destination: entryValues.deliveryagentdestination,
      pre_carriage_by: entryValues.precarriageby,
      place_of_receipt: entryValues.placeofreceipt,
      ocean_vessel: entryValues.oceanvessel,
      voy_no: entryValues.voyno,
      port_of_loading: entryValues.portofloading,
      port_of_discharge: entryValues.portofdischarge,
      port_of_dly: entryValues.portofdly,
      mode: entryValues.mode_,
      route: entryValues.route_,
      freight_chages_amt: entryValues.freightchagesamt,
      freight_payable_at: entryValues.freightpayableat,
      no_original_bl_mtd: entryValues.nooriginalblmtd,
      place_date_issue: entryValues.placedateissue,
      other_particulars: entryValues.otherparticulars,
      shipped_on_board: entryValues.shippedonboard,
      updated_by:entryValues.updatedby
    };

    BillEntryService.insertEntry(SaveEntry).then((res) => {
      setOpen(true);
      setSeverity("success");
      setMessage(res.data);
      getEntryDetails();
      refreshEntry();
    });
  };

  const UpdateEntryData = () => {

    let updateEntry = {

      export_id:entryValues.exportid,
      bl_no: entryValues.blno,
      consignee_adrs: entryValues.consigneeadrs,
      notify_adrs: entryValues.notifyadrs,
      shipper_adrs: entryValues.shipperadrs,
      delivery_agent_destination: entryValues.deliveryagentdestination,
      pre_carriage_by: entryValues.precarriageby,
      place_of_receipt: entryValues.placeofreceipt,
      ocean_vessel: entryValues.oceanvessel,
      voy_no: entryValues.voyno,
      port_of_loading: entryValues.portofloading,
      port_of_discharge: entryValues.portofdischarge,
      port_of_dly: entryValues.portofdly,
      mode: entryValues.mode_,
      route: entryValues.route_,
      freight_chages_amt: entryValues.freightchagesamt,
      freight_payable_at: entryValues.freightpayableat,
      no_original_bl_mtd: entryValues.nooriginalblmtd,
      place_date_issue: entryValues.placedateissue,
      other_particulars: entryValues.otherparticulars,
      shipped_on_board: entryValues.shippedonboard,
      updated_by: entryValues.updatedby,
    };

    BillEntryService.updateEntry(updateEntry).then((res) => {
      setOpen(true);
      setSeverity("success");
      setMessage(res.data);
      getEntryDetails();
      refreshEntry();
    });
  };

  const refreshEntry = () => {
    setEntryValues({
      ...entryValues,

      blno: "",
      consigneeadrs: "",
      notifyadrs: "",
      shipperadrs: "",
      deliveryagentdestination: "",
      precarriageby: "",
      placeofreceipt: "",
      oceanvessel: "",
      voyno: "",
      portofloading: "",
      portofdischarge: "",
      portofdly: "",
      mode_: "",
      route_: "",
      freightchagesamt: "",
      freightpayableat: "",
      nooriginalblmtd: "",
      placedateissue: "",
      otherparticulars: "",
      shippedonboard: "",
      updatedby: "",
    });
    setSaveDsa(false);
    setUpdateDsa(true);
    setPrintDsa(true);
    setAddDetailsDsa(true);
    getEntryDetails();
  };

  const blnoKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("consignee").focus();
    }
  };
  const consigneeKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("notify").focus();
    }
  };
  const notifyKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("shipper").focus();
    }
  };
  const shipperKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("destination").focus();
    }
  };
  const destinationKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("precarriageby").focus();
    }
  };
  const precarriagebyKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("placeofreceipt").focus();
    }
  };

  const placeofreceiptKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("oceanvessel").focus();
    }
  };
  const oceanvesselKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("voyno").focus();
    }
  };
  const voynoKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("portofloading").focus();
    }
  };
  const portofloadingKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("portofdischarge").focus();
    }
  };
  const portofdischargeKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("portofdly").focus();
    }
  };
  const portofdlyKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("mode").focus();
    }
  };
  const modeKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("route").focus();
    }
  };
  const routeKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("freightchages").focus();
    }
  };
  const freightchagesKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("freightpayableat").focus();
    }
  };
  const freightpayableKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("nooriginalblmtd").focus();
    }
  };
  const nooriginalblmtdKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("placedateissue").focus();
    }
  };
  const placedateissueKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("otherparticulars").focus();
    }
  };
  const otherparticularsKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("shippedonboard").focus();
    }
  };
  const shippedonboardKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("updatedby").focus();
    }
  };
  const updatedbyKeyDown = (e) => {
    if (e.key === "Enter") {
      document.getElementById("blno").focus();
    }
  };

  const getEntryDetails = () => {
    BillEntryService.getEntry().then((res) => {
      setEntryDetails(res.data);
    });
  };

  //  ADD DETAILS DIALOG HANDLE CHANGE

  const handleClickOpenAddDetails = () => {
    setOpenAddDetails(true);
    BillEntryService.getAddDetails(entryValues.blno).then((res) => {
      if (res.data.code === "200") {
        setAddDetailsDialog(res.data);
      } else {
        setAddDetailsDialog([]);
        getAddDetailsDialog();
      }
    });
  };
  const handleCloseAddDetails = () => {
    setOpenAddDetails(false);
    ResetAddDetailsDialog();
  };

  const handleClose = () => {
    setOpen(false);
  };
  //  GET ADD DETAILS DIALOG

  const getAddDetailsDialog = () => {
    BillEntryService.getAddDetails(entryValues.blno).then((res) => {
      setAddDetailsDialog(res.data);
    });
  };

  useEffect(() => {
    getEntryDetails();
    setUpdateDsa(true);
    setPrintDsa(true);
    setAddDetailsDsa(true);
  }, []);

  const [addDetailsvalues, setAddDetailsvalues] = useState({

    entrydsid:"",
    blno: "",
    markerno: "",
    containerno: "",
    sealno: "",
    containersize: "",
    desofgoods: "",
    totcarton: "",
    totpcs: "",
    invoiceno: "",
    iecno: "",
    hscode: "",
    sbno: "",
    grosswt: "",
    invoicedate: "",
    netweight: "",
    sbdate: "",
    cbm_: "",
    notifyto: "",
    volume_: "",
    mode_: "",
    
  });


  const handleDialogmarkerno = (e) => {
    setAddDetailsvalues({...addDetailsvalues, markerno: e.target.value,});
  };
  const handleDialogcontainerno = (e) => {
    setAddDetailsvalues({...addDetailsvalues, containerno: e.target.value,});
  };
  const handleDialogsealno = (e) => {
    setAddDetailsvalues({...addDetailsvalues, sealno: e.target.value,});
  };
  const handleDialogcontainersize = (e) => {
    setAddDetailsvalues({...addDetailsvalues, containersize: e.target.value,});
  };
  const handleDialogdesofgoods = (e) => {
    setAddDetailsvalues({...addDetailsvalues, desofgoods: e.target.value,});
  };
  const handleDialogtotcarton = (e) => {
    setAddDetailsvalues({...addDetailsvalues, totcarton: e.target.value,});
  };
  const handleDialogtotpcs = (e) => {
    setAddDetailsvalues({...addDetailsvalues, totpcs: e.target.value,});
  };
  const handleDialoginvoiceno = (e) => {
    setAddDetailsvalues({...addDetailsvalues, invoiceno: e.target.value,});
  };
  const handleDialogiecno = (e) => {
    setAddDetailsvalues({...addDetailsvalues, iecno: e.target.value,});
  };
  const handleDialoghscode = (e) => {
    setAddDetailsvalues({...addDetailsvalues, hscode: e.target.value,});
  };
  const handleDialogsbno = (e) => {
    setAddDetailsvalues({...addDetailsvalues, sbno: e.target.value,});
  };
  const handleDialoggrosswt = (e) => {
    setAddDetailsvalues({...addDetailsvalues, grosswt: e.target.value,});
  };
  const handleDialoginvoicedate = (e) => {
    setAddDetailsvalues({...addDetailsvalues, invoicedate: e.target.value,});
  };
  const handleDialognetweight = (e) => {
    setAddDetailsvalues({...addDetailsvalues, netweight: e.target.value,});
  };
  const handleDialogsbdate = (e) => {
    setAddDetailsvalues({...addDetailsvalues, sbdate: e.target.value,});
  };
  const handleDialogcbm = (e) => {
    setAddDetailsvalues({...addDetailsvalues, cbm_: e.target.value,});
  };
  const handleDialognotifyto = (e) => {
    setAddDetailsvalues({...addDetailsvalues, notifyto: e.target.value,});
  };
  const handleDialogvolume = (e) => {
    setAddDetailsvalues({...addDetailsvalues, volume_: e.target.value,});
  };
  const handleDialogmode = (e) => {
    setAddDetailsvalues({...addDetailsvalues, mode_: e.target.value,});
  };
 

  const EditDetailsDialog = (edd) => {
    setAddDetailsvalues({
      ...addDetailsvalues,

      entrydsid:edd.entry_ds_id,
      blno: edd.bl_no,
      markerno: edd.marker_no,
      containerno: edd.container_no,
      sealno: edd.seal_no,
      containersize: edd.container_size,
      desofgoods: edd.des_of_goods,
      totcarton: edd.tot_carton,
      totpcs: edd.tot_pcs,
      invoiceno: edd.invoice_no,
      iecno: edd.iec_no,
      hscode:edd.hs_code,
      sbno:edd.sb_no,
      grosswt:edd.gross_wt,
      invoicedate:edd.invoice_date,
      netweight:edd.net_weight,
      sbdate:edd.sb_date,
      cbm_:edd.cbm,
      notifyto:edd.notify_to,
      volume_:edd.volume,
      mode_:edd.mode

    });
    setSaveAddDetailsDsa(true);
    setUpdateAddDetailsDsa(false);
  };

  const SaveAddDetailsDialog = () => {

    let saveAddDetails = {
      
      bl_no:entryValues.blno,
      marker_no:addDetailsvalues.markerno,
      container_no:addDetailsvalues.containerno,
      seal_no:addDetailsvalues.sealno,
      container_size:addDetailsvalues.containersize,
      des_of_goods:addDetailsvalues.desofgoods,
      tot_carton:addDetailsvalues.totcarton,
      tot_pcs:addDetailsvalues.totpcs,
      invoice_no:addDetailsvalues.invoiceno,
      iec_no:addDetailsvalues.iecno,
      hs_code:addDetailsvalues.hscode,
      sb_no:addDetailsvalues.sbno,
      gross_wt:addDetailsvalues.grosswt,
      invoice_date:addDetailsvalues.invoicedate,
      net_weight:addDetailsvalues.netweight,
      sb_date:addDetailsvalues.sbdate,
      cbm:addDetailsvalues.cbm_,
      notify_to:addDetailsvalues.notifyto,
      volume:addDetailsvalues.volume_,
      mode:addDetailsvalues.mode_

    };

    BillEntryService.insertAddDetails(saveAddDetails).then((res) => {
      setOpen(true);
      setSeverity("success");
      setMessage(res.data);
      ResetAddDetailsDialog();
      getAddDetailsDialog();
    });
  };

  const UpdateAddDetailsDialog = () => {

    let updateAddDetails = {

      entry_ds_id:addDetailsvalues.entrydsid,
      bl_no:entryValues.blno,
      marker_no:addDetailsvalues.markerno,
      container_no:addDetailsvalues.containerno,
      seal_no:addDetailsvalues.sealno,
      container_size:addDetailsvalues.containersize,
      des_of_goods:addDetailsvalues.desofgoods,
      tot_carton:addDetailsvalues.totcarton,
      tot_pcs:addDetailsvalues.totpcs,
      invoice_no:addDetailsvalues.invoiceno,
      iec_no:addDetailsvalues.iecno,
      hs_code:addDetailsvalues.hscode,
      sb_no:addDetailsvalues.sbno,
      gross_wt:addDetailsvalues.grosswt,
      invoice_date:addDetailsvalues.invoicedate,
      net_weight:addDetailsvalues.netweight,
      sb_date:addDetailsvalues.sbdate,
      cbm:addDetailsvalues.cbm_,
      notify_to:addDetailsvalues.notifyto,
      volume:addDetailsvalues.volume_,
      mode:addDetailsvalues.mode_
    };

    BillEntryService.updateAddDetails(updateAddDetails).then((res) => {
      setOpen(true);
      setSeverity("success");
      setMessage(res.data);
      ResetAddDetailsDialog();
      getAddDetailsDialog();
    });
  };

  const ResetAddDetailsDialog = () => {
    setAddDetailsvalues({
      ...addDetailsvalues,

      blno: "",
      markerno: "",
      containerno: "",
      sealno: "",
      containersize: "",
      desofgoods: "",
      totcarton: "",
      totpcs: "",
      invoiceno: "",
      iecno: "",
      hscode: "",
      sbno: "",
      grosswt: "",
      invoicedate: "",
      netweight: "",
      sbdate: "",
      cbm_: "",
      notifyto: "",
      volume_: "",
      mode_: "",
    });
    getAddDetailsDialog();
    setSaveAddDetailsDsa(false);
    setUpdateAddDetailsDsa(true);
  };

  const printExport = () => {
    var details = {
      bl_no:entryValues.blno
  };
    BillEntryService.InvoicePdf(details).then((res) => {
      const message = res.data.message;
      window.open(
        "http://35.154.221.117:8081/ExportFiles/" + message.toString(),
        "_blank"
      );
    });
  };
  return (
    <>
      <Snackbar
        open={open}
        message={message}
        severity={severity}
        onClose={handleClose}
        autoHideDuration={2500}
      >
        <Alert
          className=""
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Successfully Inserted..!
        </Alert>
      </Snackbar>

      <Home />
      {/* ADD DETAILS DIALOG */}
      <Dialog maxWidth open={openAddDetails}>
        <Card className="!w-[1200px] flex flex-col  items-center !overflow-auto">
          <div className="w-full bg-blue-400 flex justify-between items-center p-2 font-bold text-white !pl-4">
            <div>BL / ENTRY DETAILS</div>
            <div className="text-center text-3xl">
              {entryValues.blno}
            </div>
            <div className="">
              <IconButton onClick={handleCloseAddDetails}>
                <CloseIcon className="text-white" />
              </IconButton>
            </div>
          </div>

          <Card className="!flex !flex-wrap justify-center gap-2 !bg-[#F0EBE3] border !border-blue-300 !rounded-lg !p-2 !m-2 !overflow-auto">
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                BL No
              </label>
              <Form.Control
                disabled
                value={entryValues.blno}
                className="!w-[220px] !border border-black !cursor-not-allowed"
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Marks & Number
              </label>
              <Form.Control
                value={addDetailsvalues.markerno}
                onChange={handleDialogmarkerno}
                className="!w-[220px] !border border-black"
                size="sm"
                type="text"
              />
            </div>

            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Container No
              </label>
              <Form.Control
                value={addDetailsvalues.containerno}
                onChange={handleDialogcontainerno}
                className="!w-[220px] !border border-black"
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Seal No
              </label>
              <Form.Control
                value={addDetailsvalues.sealno}
                onChange={handleDialogsealno}
                className="!w-[220px] !border border-black"
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
              Container Size
              </label>
              <Form.Control
                value={addDetailsvalues.containersize}
                onChange={handleDialogcontainersize}
                className="!w-[220px] !border border-black"
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Description of good
              </label>
              <Form.Control
                value={addDetailsvalues.desofgoods}
                onChange={handleDialogdesofgoods}
                className="!w-[220px] !border border-black"
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Total Carton
              </label>
              <Form.Control
                value={addDetailsvalues.totcarton}
                onChange={handleDialogtotcarton}
                className="!w-[220px] !border border-black"
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Total Pieces
              </label>
              <Form.Control
                value={addDetailsvalues.totpcs}
                className="!w-[220px] !border border-black"
                onChange={handleDialogtotpcs}
                size="sm"
                type="text"
              />
            </div>
           
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Invoice No
              </label>
              <Form.Control
                value={addDetailsvalues.invoiceno}
                className="!w-[220px] !border border-black"
                onChange={handleDialoginvoiceno}
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Invoice Date
              </label>
              <Form.Control
                value={addDetailsvalues.invoicedate}
                className="!w-[220px] !border border-black"
                onChange={handleDialoginvoicedate}
                size="sm"
                type="date"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                IEC No
              </label>
              <Form.Control
                value={addDetailsvalues.iecno}
                className="!w-[220px] !border border-black"
                onChange={handleDialogiecno}
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                HS Code
              </label>
              <Form.Control
                value={addDetailsvalues.hscode}
                className="!w-[220px] !border border-black"
                onChange={handleDialoghscode}
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                SB No
              </label>
              <Form.Control
                value={addDetailsvalues.sbno}
                className="!w-[220px] !border border-black"
                onChange={handleDialogsbno}
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                SB Date
              </label>
              <Form.Control
                value={addDetailsvalues.sbdate}
                className="!w-[220px] !border border-black"
                onChange={handleDialogsbdate}
                size="sm"
                type="date"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Gross Weight
              </label>
              <Form.Control
                value={addDetailsvalues.grosswt}
                className="!w-[220px] !border border-black"
                onChange={handleDialoggrosswt}
                size="sm"
                type="number"
              />
            </div>
            
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Net Weight
              </label>
              <Form.Control
                value={addDetailsvalues.netweight}
                className="!w-[220px] !border border-black"
                onChange={handleDialognetweight}
                size="sm"
                type="number"
              />
            </div>
          
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                CBM
              </label>
              <Form.Control
                
                value={addDetailsvalues.cbm_}
                className="!w-[220px] !border border-black"
                onChange={handleDialogcbm}
                size="sm"
                type="number"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Notify To
              </label>
              <Form.Control
                value={addDetailsvalues.notifyto}
                className="!w-[220px] !border border-black"
                onChange={handleDialognotifyto}
                size="sm"
                type="text"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Volume
              </label>
              <Form.Control
                value={addDetailsvalues.volume_}
                className="!w-[220px] !border border-black"
                onChange={handleDialogvolume}
                size="sm"
                type="number"
              />
            </div>
            <div className="">
              <label className="!text-[red] !font-bold mr-2 !mb-1 w-full text-center">
                Mode
              </label>
              <Form.Control
                value={addDetailsvalues.mode_}
                className="!w-[220px] !border border-black"
                onChange={handleDialogmode}
                size="sm"
                type="text"
              />
            </div>
          </Card>

          <Card className="px-10 flex justify-center gap-2 mb-2 !bg-[#F0EBE3] py-3 !border !border-blue-300 !rounded-lg">
            <Button
              size="small"
              className="!capitalize !w-[150px]"
              variant="contained"
              onClick={SaveAddDetailsDialog}
              disabled={saveAddDetailsDsa}
              color={saveAddDetailsDsa ? "error" : "success"}
            >
              Save
            </Button>
            <Button
              size="small"
              className="!capitalize !w-[150px]"
              variant="contained"
              onClick={UpdateAddDetailsDialog}
              disabled={updateAddDetailsDsa}
              color={updateAddDetailsDsa ? "error" : "secondary"}
            >
              Update
            </Button>
            <Button
              size="small"
              className="!capitalize !w-[150px]"
              variant="contained"
              onClick={ResetAddDetailsDialog}
              color="warning"
            >
              Reset
            </Button>
          </Card>

          <Card className="!w-full">
            <TableContainer
              className="!h-[160px] !overflow-auto"
              component={Paper}
            >
              <Table className="">
                <TableHead>
                  <TableRow className="!bg-blue-400 !sticky !top-0">
                  
                   
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                       BL No
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Marks and Number
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Container No
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Seal No
                    </TableCell>
                    <TableCell className="border border-white !text-sm !font-bold !text-[white]">
                   Description of goods
                    </TableCell>
                  {/*  <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Container Size
                    </TableCell>
                     <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Description of goods
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Total Carton
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Total Pieces
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Invoice No
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      IEC No
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      HS Code
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      SB No
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Gross Weight
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Invoice Date
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Invoice Date
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Net Weight
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      SB Date
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      CBM
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Notify To
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Volume
                    </TableCell>
                    <TableCell className="border border-white !text-sm  !font-bold !text-[white]">
                      Mode
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody className="">
                  {addDetailsDialog.map((item) => (
                    <TableRow
                      onClick={() => EditDetailsDialog(item)}
                      className="!h-10 hover:bg-[#F0EBE3] hover:!text-lg !text-center"
                      key={item.id}
                    >
                      {/* <TableCell>{i + 1}</TableCell> */}
                     
                     
                      <TableCell className="!text-sm !text-center">
                        {item.bl_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.marker_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.container_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-wrap !text-center">
                        {item.seal_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.des_of_goods}
                      </TableCell>
                      {/*  <TableCell className="!text-sm !text-center">
                        {item.container_size}
                      </TableCell>
                     <TableCell className="!text-sm !text-center">
                        {item.des_of_goods}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.tot_carton}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.tot_pcs}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.invoice_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.iec_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.hs_code}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.sb_no}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.gross_wt}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.invoice_date}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.net_weight}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.sb_date}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.cbm}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.notify_to}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.volume}
                      </TableCell>
                      <TableCell className="!text-sm !text-center">
                        {item.mode}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Card>
      </Dialog>

      {/* MAIN PAGE TEXTFIELDS */}

      <div className="ml-14 !bg-gray-200">
        <div className="!ml-10 !flex justify-between items-center">
          <div className="!text-[red] !text-2xl !font-medium mt-2 !w-full !text-center">
            BL / ENTRY
          </div>
        </div>

        <div className="!ml-10 flex gap-2 flex-wrap !m-2  !rounded-lg p-2">
          <div className="">
            <Card className="!bg-[#F6F5F2] w-fit p-4 flex flex-wrap gap-2 !rounded-lg">
              <div className="">
                <label className="!text-[red] !font-semibold ml-2 !text-sm !mb-1">
                  BL No
                </label>
                <Form.Control
                  id="blno"
                  onKeyDown={blnoKeyDown}
                  value={entryValues.blno}
                  onChange={blnohandleChange}
                  className="!border border-black !w-[220px]"
                  size="sm"
                  type="text"
                />
              </div>

              <div>
                <label className="!text-[red] !font-semibold ml-2 !text-sm !mb-1">
                  Consignee Details
                </label>
                <Form.Control
                  id="consignee"
                  onKeyDown={consigneeKeyDown}
                  value={entryValues.consigneeadrs}
                  onChange={consigneehandleChange}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div>
                <label className="!text-[red] !font-semibold ml-2 !text-sm !mb-1">
                  Notifyer Details
                </label>
                <Form.Control
                  id="notify"
                  value={entryValues.notifyadrs}
                  onKeyDown={notifyKeyDown}
                  onChange={notifyhandleChange}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div className="">
                <label className="!text-[red] !font-semibold ml-2 !text-sm !mb-1">
                Shipper Details
                </label>
                <Form.Control
                  id="shipper"
                  onKeyDown={shipperKeyDown}
                  onChange={shipperhandleChange}
                  value={entryValues.shipperadrs}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div>
                <label className="!text-[red] !font-semibold ml-2 !text-sm !mb-1">
                  Destination
                </label>
                <Form.Control
                  id="destination"
                  onKeyDown={destinationKeyDown}
                  onChange={destinationhandleChange}
                  value={entryValues.deliveryagentdestination}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div className="">
                <label className="!text-[red] !font-semibold mr-2 !text-sm !mb-1">
                Pre-Carriage By
                </label>
                <Form.Control
                  id="precarriageby"
                  onKeyDown={precarriagebyKeyDown}
                  onChange={precarriagebyhandleChange}
                  value={entryValues.precarriageby}
                  className="!border border-black !w-[220px]"
                  size="sm"
                  type="text"
                />
              </div>

              <div className="">
                <label className="!text-[red] !font-semibold mr-2 !text-sm !mb-1">
                  Place Of Receipt
                </label>
                <Form.Control
                  id="placeofreceipt"
                  onKeyDown={placeofreceiptKeyDown}
                  onChange={placeofreceipthandleChange}
                  value={entryValues.placeofreceipt}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Shipped on board
                </label>
                <Form.Control
                  id="shippedonboard"
                  onKeyDown={shippedonboardKeyDown}
                  onChange={shippedonboardhandleChange}
                  value={entryValues.shippedonboard}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="date"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Ocean Vessel
                </label>
                <Form.Control
                  id="oceanvessel"
                  onKeyDown={oceanvesselKeyDown}
                  onChange={oceanvesselhandleChange}
                  value={entryValues.oceanvessel}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                  Voy No
                </label>
                <Form.Control
                  id="voyno"
                  onKeyDown={voynoKeyDown}
                  onChange={voynohandleChange}
                  value={entryValues.voyno}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Port of loading
                </label>
                <Form.Control
                  id="portofloading"
                  onKeyDown={portofloadingKeyDown}
                  onChange={portofloadinghandleChange}
                  value={entryValues.portofloading}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Port of discharge
                </label>
                <Form.Control
                  id="portofdischarge"
                  onKeyDown={portofdischargeKeyDown}
                  onChange={portofdischargehandleChange}
                  value={entryValues.portofdischarge}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>

              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                  Port Of Delivery
                </label>
                <Form.Control
                  id="portofdly"
                  onKeyDown={portofdlyKeyDown}
                  onChange={portofdlyhandleChange}
                  value={entryValues.portofdly}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                 Mode
                </label>
                <Form.Control
                  id="mode"
                  onKeyDown={modeKeyDown}
                  onChange={modehandleChange}
                  value={entryValues.mode_}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Route
                </label>
                <Form.Control
                  id="route"
                  onKeyDown={routeKeyDown}
                  onChange={routehandleChange}
                  value={entryValues.route_}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Freight Chages Amt
                </label>
                <Form.Control
                  id="freightchages"
                  onKeyDown={freightchagesKeyDown}
                  onChange={freightchagesamthandleChange}
                  value={entryValues.freightchagesamt}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Freight Payable At
                </label>
                <Form.Control
                  id="freightpayableat"
                  onKeyDown={freightpayableKeyDown}
                  onChange={freightpayableathandleChange}
                  value={entryValues.freightpayableat}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                No.Of Original BL/MTD
                </label>
                <Form.Control
                  id="nooriginalblmtd"
                  onKeyDown={nooriginalblmtdKeyDown}
                  onChange={nooriginalblmtdhandleChange}
                  value={entryValues.nooriginalblmtd}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Place
                </label>
                <Form.Control
                  id="placedateissue"
                  onKeyDown={placedateissueKeyDown}
                  onChange={placedateissuehandleChange}
                  value={entryValues.placedateissue}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
              <div className="">
                <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Others
                </label>
                <Form.Control
                  id="otherparticulars"
                  // as={TextareaAutosize}
                  // maxLength={2}
                  onKeyDown={otherparticularsKeyDown}
                  onChange={otherparticularshandleChange}
                  value={entryValues.otherparticulars}
                   className="!border border-black !w-[220px] !h-[15px]"
                  size="sm"
                  type="text"
                />
              </div>
            
              <div className="">
                {/* <label className="!text-[black] !font-semibold mr-2 !text-sm !mb-1">
                Updated By
                </label> */}
                <Form.Control
                hidden
                  id="updatedby"
                  onKeyDown={updatedbyKeyDown}
                  onChange={updatedbyhandleChange}
                  value={entryValues.updatedby}
                  className="!w-[220px] !border border-black"
                  size="sm"
                  type="text"
                />
              </div>
            </Card>
          </div>
        </div>

        <Card className="flex justify-center shadow-lg gap-4 !bg-[#F1F1F2] !p-2 rounded-lg !mb-4">
          <Button
            className="w-[100px] hover:!shadow-sm hover:!shadow-black !text-white !capitalize"
            size="small"
            color={saveDsa ? "error" : "success"}
            variant="contained"
            disabled={saveDsa}
            onClick={SaveEntryData}
          >
            Save
          </Button>
          <Button
            className="w-[100px] hover:!shadow-sm hover:!shadow-black !text-white !capitalize"
            size="small"
            color={updateDsa ? "error" : "secondary"}
            variant="contained"
            disabled={updateDsa}
            onClick={UpdateEntryData}
          >
            Update
          </Button>
          <Button
            className="w-[100px] hover:!shadow-sm hover:!shadow-black !text-white !capitalize"
            size="small"
            color="warning"
            variant="contained"
            onClick={refreshEntry}
          >
            Reset
          </Button>
          <Button
            className="w-[100px] hover:!shadow-sm hover:!shadow-black !text-white !capitalize"
            size="small"
            color={addDetailsDsa ? "error" : "primary"}
            variant="contained"
            disabled={addDetailsDsa}
            onClick={handleClickOpenAddDetails}
          >
            Details
          </Button>
          <Button
            className="w-[100px] hover:!shadow-sm hover:!shadow-black !text-white !capitalize"
            size="small"
            disabled={printDsa}
            color={printDsa ? "error" : "error"}
            variant="contained"
            onClick={printExport}
          >
            Print
          </Button>
        </Card>

        <Card className=" bg-[#E1E5EB] !flex flex-col !ml-10">
        <TableContainer className="!h-[200px]" component={Paper}>
            <Table className="">
              <TableHead>
                <TableRow className=" bg-[#4582B0] !sticky !top-0">
                  {/* <TableCell className="border border-white !text-sm !text-center !text-white">
                    Export Id
                  </TableCell> */}
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                   BL NO
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                    CONSIGNEE
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                    NOTIFYER
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                    SHIPPER
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                    DESTINATION
                  </TableCell>
                  {/* <TableCell className="border border-white !text-sm !text-center !text-white">
                  precarriageby
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  placeofreceipt
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  oceanvessel
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  voyno
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  portofloading
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  portofdischarge
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  portofdly
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  mode
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  route
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  freightchagesamt
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  freightpayableat
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  nooriginalblmtd
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  placedateissue
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  otherparticulars
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  shippedonboard
                  </TableCell>
                  <TableCell className="border border-white !text-sm !text-center !text-white">
                  updatedby
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody className="">
                {entryDetails.map((entry) => (
                  <TableRow
                    className="!h-10 !truncate !text-wrap hover:bg-slate-200 hover:!text-lg"
                    onClick={() => EditEntryData(entry)}
                    key={entry.id}
                  >
                    {/* <TableCell className="text-center !text-xs">
                      {entry.export_id}
                    </TableCell> */}
                    <TableCell className="text-center !text-xs">
                      {entry.bl_no}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.consignee_adrs}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.notify_adrs}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.shipper_adrs}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.delivery_agent_destination}
                    </TableCell>
                    {/* <TableCell className="text-center !text-xs">
                      {entry.pre_carriage_by}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.place_of_receipt}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.ocean_vessel}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.voy_no}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.port_of_loading}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.port_of_discharge}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.port_of_dly}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.mode}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.route}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.freight_chages_amt}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.freight_payable_at}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.no_original_bl_mtd}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.place_date_issue}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.other_particulars}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.shipped_on_board}
                    </TableCell>
                    <TableCell className="text-center !text-xs">
                      {entry.updated_by}
                    </TableCell> */}

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
    </>
  );
}
